
export const MiscType = {

  setConsumerProfile:'setConsumerProfile',
  setFullName:'setFullName',
  setBusinessName:'setBusinessName',
  setAgentId:'setAgentId',
  selectedConsumerList: 'selectedConsumerList',
  setTotalDueList:'setTotalDueList',
  setBatch: 'setBatch',
  selectedRow:'selectedRow',
  setSelectedAmount: 'setSelectedAmount',
  setBatchConsumers: 'setBatchConsumers',
  totalConsumerNo: 'totalConsumerNo',
  totalInActiveConsumers: 'totalInActiveConsumers',
  totalActiveConsumers: 'totalActiveConsumers',
  selectDueDate:'selectDueDate',
  setStartDate:'setStartDate',
  setEndDate:'setEndDate',
  setClaimResp:'setClaimResp',
  setTransactionTimeStamp: 'setTransactionTimeStamp',
  setDeviceInfo: "setDeviceInfo",
  setConsumerAddresp:'setConsumerAddresp',
  setBillListConsumers:'setBillListConsumers',
  setBillListStartIndex:'setBillListStartIndex',
  setBillListEndIndex:'setBillListEndIndex',

  setBillListTotalAmount:'setBillListTotalAmount',
  setBillListKeys:'setBillListKeys',

  setActiveLinkStatus: "setActiveLinkStatus",
  setToken: "setToken",
  setAgentInfo: "setAgentInfo",

  setStateDetails: "setStateDetails",
  setCityList: "setCityList",
  setBranchList: "setBranchList",
  setIfscCode: "setIfscCode",

  setBankDetails: "setBankDetails",
  selectedBankName: "selectedBankName",
  setSelecetedBankDetails: "setSelecetedBankDetails",
  setSelectedBankName: "setSelectedBankName",
  setSelectedBankId: "setSelectedBankId",

  setBranchAddress: "setBranchAddress",

  setActiveStatus: "setActiveStatus",
  setLogOutWarningStatus: "setLogOutWarningStatus",
  setLoginTimestamp: "setLoginTimestamp",
  setCustomerLimit: "setCustomerLimit",


  setGraphResponse: "setGraphResponse",
  setPartner: 'setPartner',
  setRequesterId: 'setRequesterId',
  setLogoName: 'setLogoName',
  setClientRole: 'setClientRole',
  setTaLoadPermission: 'setTaLoadPermission',

  setFilterStartDate: 'setFilterStartDate',
  setFilterEndDate: 'setFilterEndDate',
  setMiscCallBackUrl: 'setMiscCallBackUrl',
  setRetailerBlance: 'setRetailerBlance',
  setClaimLoadShow: 'setClaimLoadShow',
  setRetailerBalanceVal: 'setRetailerBalanceVal',
  setDashboardPageGraphMonth: 'setDashboardPageGraphMonth',
  setTimeoutModal: 'setTimeoutModal',

  setShowAll: 'setShowAll',
  setService: 'setService',
  setLogoutEnabled:'setLogoutEnabled',

  RESET: "RESET"
};